<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>系统配置</el-breadcrumb-item>
            <el-breadcrumb-item>资讯动态</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!--  -->
          <div class="build-table">
            <div
              style="display:flex;border-top:10px solid #f5f5f5;width:100%;height:80px;align-items:center;justify-content: flex-end;padding:0px 10px"
            >
              <!-- <el-input
                v-model="search.name"
                placeholder="请输入试卷名称"
                clearable
                @input="watchInput"
                style="width:220px;padding:10px"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input> -->
              <el-button type="primary" icon="el-icon-plus" @click="addFun">添加资讯</el-button>
            </div>
            <!--  -->
            <div style="width:100%;height:calc(100% - 140px)">
              <el-table
                stripe
                :data="listData"
                height="100%"
                style="width: 100%;"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
                :cell-style="rowClass"
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="100">
                  <template slot-scope="scope">
                    <a>{{ scope.row.index}}</a>
                  </template>
                </el-table-column>
                  <el-table-column label="图片">
                  <template slot-scope="scope">
                     <el-image v-if="scope.row.photoUrl1.split('.')[scope.row.photoUrl1.split('.').length-1]!='mp4'" style="width: 50px; height: 50px"  :src="scope.row.photoUrl1"   :preview-src-list="scope.row.srcList">
                     </el-image>
                     <video  v-if="scope.row.photoUrl1.split('.')[scope.row.photoUrl1.split('.').length-1]=='mp4'" style="width: 50px; height: 50px"  :src="scope.row.photoUrl1">
                     </video>
                  </template>
                </el-table-column>
                <el-table-column label="标题">
                  <template slot-scope="scope">
                    <a>{{ scope.row.title}}</a>
                  </template>
                </el-table-column>
                <el-table-column label="内容" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{ scope.row.content }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="日期">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createDate }}</span>
                  </template>
                </el-table-column>
                      <el-table-column label="排序">
                  <template slot-scope="scope">
                    <span>{{ scope.row.sort }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      icon="el-icon-edit"
                      @click="handleEdit(scope.$index, scope.row)"
                    ></el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="handleDel(scope.$index, scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 添加公告弹框 -->
              <!-- 新增窗口 -->
              <el-dialog
                :title="dialogTitle"
                :visible.sync="addFormVisible"
                center
                width="600px"
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
              >
                <el-form :model="addForm" label-width="200px" ref="addForm" label-position="right" :rules="rules">
                  <el-form-item label="标题封面">
                     <el-upload
                     :on-progress="progress"
                       class="avatar-uploader video-avatar"
                       v-bind:action="uploadphotoUrl"
                       :headers="uploadHead"
                       :data="uploadphotoData"
                       :show-file-list="false"
                       :on-success="handleIconSuccess"
                       :before-upload="uploadHandle"
                     >
                       <img v-if="!isShow&&photoUrl_view" :src="photoUrl_view" class="avatar video-avatar" />
                       <video  v-else-if="isShow" :src="photoUrl_view" style="width:12vw"></video>
                       <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                     </el-upload>
                     <span v-if="done">{{done}}</span>
                  </el-form-item>
                  <el-form-item label="标题：" prop="title">
                    <el-input v-model="addForm.title" autocomplete="off" style="width:217px"></el-input>
                  </el-form-item>
                   <el-form-item label="内容：" prop="content">
                    <el-input type="textarea" :rows="4" v-model="addForm.content" autocomplete="off" style="width:217px;"></el-input>
                  </el-form-item>         
                    <el-form-item label="排序：" prop="sort">
                    <el-input v-model="addForm.sort" autocomplete="off" style="width:217px;"></el-input>
                  </el-form-item>                
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog>
            </div>
            <!-- 分页展示 -->
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10,20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
              ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      search: {
        //查询
        name: '',
        groupId: '',
        joinType:''
      },
      listData: [], //表格数据
      addForm: {
        // groupType:'1',//组织类型，1项目，2施工企业，3建设企业
        id: '',
        title:'', //标题
        content:'',//内容
        photoUrl :'', //图片路径
        sort:''
      },
      dialogTitle: '',
      addFormVisible: false,
      groupId: '',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      storeOpt: [], //题库
       uploadphotoUrl: base.url+"/upload/uploadPhoto",
         uploadHead: {
        accessToken: util.session.get('token')
      },
      uploadphotoData: {
        type: '219'
      },
      dataText: '数据加载中...',
      rules: {
       title :[{ required: true, message: '请输入标题', trigger: 'blur' } ],
       content: [{ required: true, message: '请输入内容', trigger: 'blur' } ],
       sort: [{ required: true, message: '请输入排序数字', trigger: 'blur' } ],
      },
      groupType: '',
      groupId:'',
      createBy:util.session.get('user').id,
      photoUrl_view:'',
      isShow:false,
      done:'',
      doneLock:true
    }
  },

  mounted() {
    this.groupId = util.session.get('groupId')
    // console.log(this.addForm.scope)
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.$store.commit('getRoleId')
      this.groupId = this.$store.state.groupId
    }
    this.search.groupId = this.groupId
    if (util.session.get('roleId') == '3') {
      this.groupType = '3'
    } else if (this.$store.state.roleId == '4') {
      this.groupType = '1'
    } else if (util.session.get('roleId') == '5') {
      this.groupType = '2'
    }
    // console.log(this.groupId)
    this.getData()
  
  },
  methods: {
    uploadHandle(item){
      console.log(item)
      if(item.type.split('/')[1]=='mp4'||item.type.split('/')[1]=='png'||item.type.split('/')[1]=='jpg'||item.type.split('/')[1]=='jpeg'||item.type.split('/')[1]=='jfif'){
        if(item.size<=419430400){
        }else{
          this.$message({
            type:'warning',
            message:'文件体积大于400MB'
          })
          return false
        }
      }else{
        this.$message({
            type:'warning',
            message:'上传文件的类型为MP4、png、jpeg、jpg'
          })
          return false
      }
    },
    // 文件上传进度
    progress(event, file, fileList){
      this.doneLock=false
      // console.log(event, file, fileList)
      // console.log(event.percent.toFixed(2)+'%')
      this.done=event.percent.toFixed(2)+'%'
    },
    //查询
    doFilter() {
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    rowClass() {
      //表头居中显示
      return 'text-align:center'
    },
    // 获取数据
    getData() {
      var that = this
      this.search.entId = this.groupId
      this.search.joinType = this.groupType
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.pageInfoNews(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            for(var i= 0;i<list.length;i++){
               list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
               list[i].photoUrl1 = list[i].photoUrl && list[i].photoUrl!=''?base.httpCtx+list[i].photoUrl:''
               list[i].srcList = list[i].photoUrl && list[i].photoUrl!=''? [base.httpCtx+list[i].photoUrl]:[]
            }
            that.totalItems = resp.data.data.total || 0
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '服务器出错'
          }
        },
        function () {}
      )
    },
    //修改
    handleEdit(index, row) {
      this.done=''
      this.dialogTitle = '修改资讯'
      var that = this
      this.addFormVisible = true;
      this.addForm.id = row.id;
      this.addForm.title = row.title;
      this.addForm.content = row.content;
      this.addForm.photoUrl = row.photoUrl
      this.addForm.sort = row.sort
      this.isShow = row.photoUrl.split('.')[row.photoUrl.split('.').length-1]=='mp4'?true:false
      this.photoUrl_view =base.httpCtx +  row.photoUrl 
      console.log(this.photoUrl_view.split('.')[this.photoUrl_view.split('.').length-1]=='mp4'?true:false)
    },
    //保存
    sumbitAddRow(formName) {
      var that = this
      this.addForm.entId = this.groupId
      // this.addForm.groupType = this.groupType
      this.addForm.createBy = this.createBy
      this.addForm.joinType = this.groupType
      if(this.doneLock){

      }else{
        this.$message({
          type:'warning',
          message:'文件正在上传中...'
        })
        return
      }
      console.log('me有出发')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!that.addForm.id) {
            myHttp.createInfoNew(that.addForm).then(function (resp) {
              if (resp.data.code == '200') {
                that.addFormVisible = false
                that.$message.success('创建成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          } else {
           this.addForm.updateBy= this.createBy
            myHttp.updateInfoNew(that.addForm).then(function (resp) {
              if (resp.data.code == '200') {
                that.addFormVisible = false
                that.$message.success('修改成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          }
        }
      })
    },
    // handleNodeClick(data) {
    //   console.log(data)
    // },
    //添加
    addFun() {
      this.done=''
      this.isShow=false
      this.photoUrl_view=""
      this.dialogTitle = '添加资讯'
      this.checkData = [];
      this.addForm = {
          id: '',
          title:'',
          content:'',
          sort:''
        },
      this.addFormVisible = true
    },
    //删除
    handleDel(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该资讯, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp.deleteInfoNew({
            id:row.id,
            updateBy:this.createBy
          }).then(function(resp){
            if(resp.data.code=="200"){
                that.$message.success('删除成功');
                that.getData();
            }else{
                that.$message.error(resp.data.msg);
            }
          });
        })
        .catch((err) => {})
    },
      // 上传封面图片成功
    handleIconSuccess(res, file) {
      if (res.code == '200') {
        this.photoUrl_view  = URL.createObjectURL(file.raw)
        console.log(res)
        this.done = '上传完毕'
        this.doneLock=true
        if(res.data.saveUrls.split('.')[res.data.saveUrls.split('.').length-1]=='mp4'?true:false){
          this.isShow=true
          this.addForm.photoUrl = res.data.saveUrls
        }else{
          this.addForm.photoUrl = res.data.saveUrls
        }
        // var time = new Date().getMilliseconds()
        // this.photoUrl_view = base.httpCtx + res.data.saveUrls 
        // console.log(this.photoUrl_view)
        // console.log(this.addForm.photoUrl)
      } else {
        this.$message.error(res.msg)
      }
    },
    // //添加选题
    // addOpt() {
    //   var length = this.strOpt.length
    //   var index = parseInt(this.strOpt[length - 1].index) + 1
    //   var obj = {
    //     index: index,
    //     type: '',
    //     num: '',
    //     score: '',
    //   }
    //   this.strOpt.push(obj)
    // },
    },
   
}
</script>
<style>
@import '../../assets/css/common.css';
.el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #ecf0f5;
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: 100%;
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-table th > .cell {
  text-align: center !important;
}
.video-avatar{
 width: 200px;
 height:200px;
}
</style>